import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useWindowSize } from 'customHooks';
import {
  Wrapper,
  HighlightedContent,
  EasyConnectionSelectionForm,
  Option,
  InsertButton,
} from './EasyConnection.styles';

const EasyConnection = (props) => {
  const [newText, setNewText] = useState('');
  const [selectedOption, setSelectedOption] = useState(null);
  const [relocationPixels, setRelocationPixels] = useState(0);
  const windowSize = useWindowSize();
  const elementRef = useRef(null);

  useEffect(() => {
    const el = elementRef && elementRef.current;

    if (!el) {
      return;
    }

    const data = el.getBoundingClientRect();
    const rightEdgeLocation = data.x + data.width;
    const pixelsOutside = rightEdgeLocation - window.innerWidth;
    if (pixelsOutside > 0) {
      setRelocationPixels(Math.floor(pixelsOutside) + 25);
    } else {
      setRelocationPixels(0);
    }
  }, [props.activeEasyConnection, windowSize]);

  const getSelectedOptionType = () => {
    const option = props.options.find((opt) => opt.text === newText);

    return option ? option.type : 'FREEHAND';
  };

  const handleInsert = (e) => {
    e.preventDefault();
    props.onReplace({
      originalText: props.triggerText,
      newText: newText.trim(),
      options: props.options,
      triggerType: getSelectedOptionType(),
    });
    props.onSetActiveEasyConnection(null);
  };

  const handleSelectMLOption = (e) => {
    const value = e.target.value;
    const isMLOption = props.options.some((option) => option.text === value);

    if (isMLOption || value === 'write_your_own') {
      setSelectedOption(value);
    }

    if (value !== 'write_your_own') {
      setNewText(value);
    } else {
      setNewText('');
    }
  };

  const handleToggleWidget = (val) => {
    if (showWidget()) {
      props.onSetActiveEasyConnection(null);
    } else {
      props.onSetActiveEasyConnection(val);
    }
  };

  const showWidget = () => {
    return props.activeEasyConnection && props.activeEasyConnection === props.triggerText;
  };

  const renderSelectionWidget = () => {
    const writeYourOwnSelected = 'write_your_own' === selectedOption;

    const initialLeftOffset = 19;
    const formLeft = 0 - initialLeftOffset - relocationPixels;
    const arrowLeft = 14 - formLeft;

    return (
      <EasyConnectionSelectionForm
        ref={elementRef}
        formLeft={formLeft}
        arrowLeft={arrowLeft}
        onChange={(e) => handleSelectMLOption(e)}
        onSubmit={(e) => handleInsert(e)}
      >
        {props.options.map((option) => (
          <Option selected={option.text === selectedOption} key={option.text}>
            <input type="radio" value={option.text} name="option" id={option.text} />
            <label htmlFor={option.text}>{option.text}</label>
          </Option>
        ))}
        <Option selected={writeYourOwnSelected}>
          <input type="radio" value="write_your_own" name="option" id={'write_your_own'} />
          {writeYourOwnSelected ? (
            <input type="text" placeholder="Enter custom text"></input>
          ) : (
            <label htmlFor={'write_your_own'}>Write your own</label>
          )}
        </Option>
        <InsertButton type="submit" width={'100%'} disabled={!newText}>
          Insert
        </InsertButton>
      </EasyConnectionSelectionForm>
    );
  };

  return (
    <Wrapper>
      {showWidget() && renderSelectionWidget()}
      <HighlightedContent
        onClick={() => handleToggleWidget(props.triggerText)}
        onMouseOver={() => handleToggleWidget(props.triggerText)}
        color={props.color}
      >
        {props.triggerText}
      </HighlightedContent>
    </Wrapper>
  );
};

EasyConnection.propTypes = {
  color: PropTypes.string.isRequired,
  triggerText: PropTypes.string.isRequired,
  activeEasyConnection: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    })
  ).isRequired,
  onReplace: PropTypes.func.isRequired,
  onSetActiveEasyConnection: PropTypes.func.isRequired,
};

export default EasyConnection;
